
import { Options, Vue } from "vue-class-component";
import Sidebar from "@/app/ui/components/sidebar/index.vue";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import Loading from "@/app/ui/components/loading/index.vue";
import Banner from "@/app/ui/views/banner/index.vue";
import FloatingBooking from "@/app/ui/components/floating-booking/index.vue";
import MultipleSnackbar from "@/app/ui/components/multiple-snackbar/index.vue";
import { FirebaseController } from "../controllers/FirebaseController";
import { playNotification } from "@/app/infrastructures/misc/UtilsAudio";
import replaceDoubleBraces from "@/app/infrastructures/misc/common-library/ReplaceDoubleBraches";
import formatDate from "@/app/infrastructures/misc/common-library/FormatDate";
import { CargoController } from "../controllers/CargoController";
import { AccountController } from "../controllers/AccountController";
import { BalanceMinusPenaltyController } from "@/app/ui/controllers/BalanceMinusPenaltyController";
import { BalanceController } from "@/app/ui/controllers/BalanceController";
import { NotificationsAll } from "@/domain/entities/BalanceMinusPenalty";
import router from "../router";

@Options({
  components: {
    Loading,
    sidebar: Sidebar,
    Banner,
    FloatingBooking,
    MultipleSnackbar
  },
  computed: {
    getCurrentRoute() {
      return this.$route;
    }
  }
})
export default class Layout extends Vue {
  created() {
    // handle scanner press CTRL+Shift+J
    document.addEventListener.call(
      window,
      "keydown",
      (event: any) =>
        event.ctrlKey &&
        event.shiftKey &&
        event.keyCode == 74 && // J
        event.preventDefault()
    );
  }
  mounted() {
    // toast realtime notification
    FirebaseController.onMessageFirebase((payload: any) => {
      console.log(
        "🚀 ~ Layout ~ FirebaseController.onMessageFirebase ~ payload:",
        payload
      );
      const severityMap: Record<string, string> = {
        success: "success",
        error: "error",
        failed: "error"
      };

      const { status } = payload.data;
      const isConsole =
        AccountController.accountData.isConsoleAccount ||
        AccountController.accountData.isSubConsoleAccount;

      this.detailMultipleSnackBar.severityNotif = status.toLowerCase();
      console.log(
        "🚀 ~ Layout ~ FirebaseController.onMessageFirebase ~ this.detailMultipleSnackBar.severityNotif:",
        this.detailMultipleSnackBar.severityNotif
      );

      if (isConsole) {
        console.log(
          "🚀 ~ Layout ~ FirebaseController.onMessageFirebase ~ cargo:"
        );
        playNotification(
          status.toLowerCase() === "failed" ? "failed_cargo" : "success_cargo"
        );
        CargoController.updateLastReadCargo();

        this.$toast.add({
          severity: severityMap[status.toLowerCase()],
          detail: `${this.messageFirebaseNotification(payload)}`,
          life: 10000
        });
      } else if (payload.data?.is_kulioner) {
        console.log(
          "🚀 ~ Layout ~ FirebaseController.onMessageFirebase ~ payload.data?.data?.is_kulioner:",
          payload.data?.is_kulioner
        );
        this.$toast.add({
          severity: "success",
          summary: payload.notification?.title,
          detail: `<div class="text-green-lp-400 truncate overflow-hidden" style="max-width: 345px;">${payload.notification?.body}</div> <a href="/kulioner?tab=ORDWTC" class="font-bold cursor-pointer text-green-lp-400">Cek Pesanan!</a>`,
          life: 10000,
          closable: true,
          iconClosePosition: "start"
        });
      } else {
        this.$toast.add({
          severity: severityMap[status.toLowerCase()] || "warning",
          detail: payload.notification.title,
          life: 10000,
          closable: false,
          id: payload.data.id
        });
      }
    });
    this.getBalanceMinus();
    this.defineMultipleSnackBar();
  }

  messageFirebaseNotification(payload: any) {
    const successBooking = `${payload.data.destination_city_code} - ${payload.data.destination_city_name}`;
    const failedBooking = payload.data.reason_failed;
    const isRTCNotif = payload.data.title === "RTC Notification";
    const notifRTC = payload.notification?.body.split(",");
    const cancelBooking = payload.data.message.includes("cancel booking");


    if (isRTCNotif) {
      return `<b>${notifRTC[0]}</b> ${notifRTC[1]}`;
    } else if (cancelBooking) { 
      return payload.data.status === "success"
        ? `<b>No. Kargo ${payload.data.cargo_no}</b> Berhasil dibatalkan`
        : `<b>No. Kargo ${payload.data.cargo_no}</b> -  Gagal dibatalkan karena <b>${failedBooking}</b>.`;
    } else {
      return payload.data.status === "success"
        ? `<b>No. Kargo ${payload.data.cargo_no}</b> Berhasil Booking kargo ke <b>${successBooking}</b>`
        : `<b>No. Kargo ${payload.data.cargo_no}</b> Gagal Booking karena <b>${failedBooking}</b>`;
    }
  }
  
  // error modal
  get responseModal() {
    return MainAppController.responseModal;
  }
  get errorModal() {
    return MainAppController.errorMessageModal;
  }
  get errorEntities() {
    return MainAppController.errorMessageEntities;
  }
  get errorTextCancel() {
    return this.errorEntities.onTryAgain ? this.$t('modalButtonBackTitle') : "";
  }
  get errorTextSuccess() {
    return this.errorEntities.onTryAgain
      ? this.$t('modalButtonTryAgainTitle')
      : this.errorEntities.buttonSuccessText;
  }
  get errorOnSubmit() {
    return this.errorEntities.onTryAgain
      ? this.errorEntities.onTryAgain
      : this.closeErrorModal;
  }
  closeErrorModal() {
    this.errorEntities.onClose && this.errorEntities.onClose();
    MainAppController.closeErrorMessage();
  }
  setCloseResponseModal() {
    MainAppController.closeResponseModal();
  }
  setConfirmResponseModal() {
    this.setCloseResponseModal();
    this.errorEntities.onClose();
  }

  // modal message
  get messageModal() {
    return MainAppController.messageModal;
  }
  get messageEntities() {
    return MainAppController.messageEntities;
  }

  // loading
  get loadingModal() {
    return MainAppController.loadingModal;
  }
  set loadingModal(bool: boolean) {
    MainAppController.setLoadingModal(bool);
  }

  // snackbar
  get snackbar() {
    return MainAppController.snackbar;
  }
  get snackbarMessage() {
    return MainAppController.snackbarMessage;
  }
  get snackbarPositive() {
    return MainAppController.snackbarPositive;
  }
  get snackbarTimeout() {
    return MainAppController.snackbarTimeout;
  }
  get snackbarAutoClose() {
    return MainAppController.snackbarAutoClose;
  }
  toggleSnackbar(bool: boolean) {
    MainAppController.setSnackbar(bool);
  }

  openCollapseSidebar() {
    AccountController.setIsCollapseSidebar(
      !AccountController.isCollapseSidebar
    );
  }
  toDashboard() {
    router.push("/");
  }

  async getBalanceMinus() {
    if (AccountController.accountData.isPosAccount 
      && AccountController.accountData.account_type_detail.isCodDelivery
    ) {
      const res = await BalanceMinusPenaltyController.getAllNotifications();
      if (this.isShowBalanceNotification) {
        res.forEach((item: NotificationsAll) => {
          const status = item.status === "info" ? "warning" : "error"
          const message = item.message;
          const dueDate: any = {
            "np_due_date": formatDate(item.dueDate)
          }
          
          const newMessage = replaceDoubleBraces(message, dueDate)
          this.$toast.add({
            severity: status,
            detail: newMessage
          });
        });
      }
    }
  }

  detailMultipleSnackBar = {
    title: "",
    isClickable: false,
    isEditable: false,
    severityNotif: ""
  };

  defineMultipleSnackBar() {
    const account =
      AccountController.accountData.account_type_detail.type ||
      AccountController.accountData.account_type;

    const isSuccess = this.detailMultipleSnackBar.severityNotif === "success";

    const detailAccount: Record<string, { title: string; isClickable: boolean; isEditable: boolean }> = {
      console: {
        title: "Notifikasi Kargo",
        isClickable: true,
        isEditable: false
      },
      pos: {
        title: "",
        isClickable: false,
        isEditable: !isSuccess
      },
      internal: {
        title: "",
        isClickable: false,
        isEditable: !isSuccess
      },
      client: {
        title: "",
        isClickable: false,
        isEditable: !isSuccess
      }
    };

    const selectedAccount = detailAccount[account] ?? { title: "", isClickable: false, isEditable: false };

    Object.assign(this.detailMultipleSnackBar, selectedAccount);
  }

  get isShowBalanceNotification() {
    return (
      AccountController.accountData.isPosAccount &&
      BalanceController.balanceData.walletBalance <= 0
    );
  }

  get isShowCargoNotification() {
    return AccountController.accountData.isConsoleAccount || AccountController.accountData.isSubConsoleAccount;
  }

  get isShowBulkBookingNotif() {
    return (
      AccountController.accountData.isPosAccount ||
      AccountController.accountData.isInternalAccount ||
      AccountController.accountData.isAllClient
    );
  }

  get isAccountForeign() {
    return AccountController.accountData.accountIsForeign;
  }

  get newLayoutDesign() {
    return (
      this.$route.name === 'bulk-v2' || this.$route.name === 'kulioner-detail' || this.$route.name === "kulioner-list" || this.$route.name === "dispatch"
    )
  }
}
